import React from 'react';
import SharedDataStep from '../shared/DataStep';
import { siteField } from '../shared/options';
import { figureListPath } from '../shared/wizardUtils';
import { DELETE_FIGURE } from '../../graphql/mutations';
import { FIGURE_FOR_EDIT_QUERY } from '../../graphql/queries';

export default function DataStep({ figure, state, sites, onNext, onCancel, loading }) {
  return (
    <SharedDataStep
      title="Basic Data"
      resource={{ ...figure, identifier: state.identifier }}
      fields={[
        { key: 'identifier', label: 'Identifier', type: 'text', value: state.identifier },
        siteField(sites, state.siteId)
      ]}
      deletion={{
        resource: { ...figure, query: FIGURE_FOR_EDIT_QUERY },
        mutation: DELETE_FIGURE,
        redirectPath: figureListPath(figure.type),
        label: 'Figure'
      }}
      onNext={onNext}
      onCancel={onCancel}
      loading={loading}
    />
  );
}
